import {
  getRecentlyViewedSpace,
  patchRecentlyViewedSpace,
} from '@core/api/spaces/getNupdateRecentlyViewedSpaces';
import { getMySpaces, getSpaceById } from '@core/selectors/space';
import { FETCH_RECENTLY_VIEWED_SPACES } from '../actions';

const fetchRecentlyViewedSpaces = () => (dispatch, getState) => {
  const state = getState();
  dispatch({
    type: FETCH_RECENTLY_VIEWED_SPACES,
    status: 'started',
  });

  getRecentlyViewedSpace()
    .then(({ data: { spaces }, status }) => {
      if (status === 200) {
        const spaceList = spaces?.spaces;
        const recentlyViewedSpaceInfo = spaceList?.map(
          ({ spaceId, ...rvs }) => {
            const assignedSpace = getSpaceById(state, spaceId); // Assigned Spaces
            const mySpaces = getMySpaces(state);

            return {
              spaceId,
              name: rvs?.name,
              archived: rvs?.archived,
              avatar: rvs?.avatar,
              lastNavigation: rvs?.lastNavigation,
              isStarred: assignedSpace?.isStarred ?? false,
              isStaffAccess: !mySpaces[spaceId],
              hasActivity: assignedSpace?.unread,
              isAssigned: assignedSpace?.objectId === spaceId,
              instructors: assignedSpace?.instructors,
              categories: assignedSpace?.categories,
            };
          },
          []
        );

        dispatch({
          type: FETCH_RECENTLY_VIEWED_SPACES,
          payload: recentlyViewedSpaceInfo,
          status: 'success',
        });
      }
    })
    .catch(() => {
      dispatch({
        type: FETCH_RECENTLY_VIEWED_SPACES,
        payload: [],
        status: 'error',
      });
    });
};

let count;
const updateRecentlyViewedSpaces = (location) => {
  const addressbarUrl = location?.pathname;

  if (
    addressbarUrl &&
    (addressbarUrl.includes('/myspacenav') ||
      addressbarUrl.includes('/community/') ||
      addressbarUrl.includes('/journey/') ||
      addressbarUrl.includes('/people/'))
  ) {
    const spaceId = addressbarUrl?.split('/')[2];
    const searchQuery = location?.search;

    clearTimeout(count);
    count = setTimeout(() => {
      patchRecentlyViewedSpace({
        spaceId,
        lastNavigation: searchQuery
          ? addressbarUrl + searchQuery
          : addressbarUrl,
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
    }, 3000);
  }
};

export { fetchRecentlyViewedSpaces, updateRecentlyViewedSpaces };
